import { render, staticRenderFns } from "./SectionsAccordion.vue?vue&type=template&id=f62c6526&scoped=true"
import script from "./SectionsAccordion.vue?vue&type=script&lang=js"
export * from "./SectionsAccordion.vue?vue&type=script&lang=js"
import style0 from "./SectionsAccordion.vue?vue&type=style&index=0&id=f62c6526&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f62c6526",
  null
  
)

export default component.exports